module.exports = __webpack_public_path__ + "static/img/advice_hiroshi.7d6289cf.png";